/** Membership roles and account labels are both returned by the Appwrite roster. */
export function isTeamAdmin(member: { roles?: string[]; labels?: string[] }) {
  return [...(member.roles || []), ...(member.labels || [])].some(value => ['owner','admin','teamadmin'].includes(value.toLowerCase()));
}
